/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/JiraBusinessApprovalsAppMemoQuery$parameters.ts';
import type { JiraBusinessApprovalsAppMemoQuery } from './__generated__/JiraBusinessApprovalsAppMemoQuery.graphql.ts';

type ApprovalsEntryPointComponent = EntryPointComponent<
	{
		approvalsQuery: JiraBusinessApprovalsAppMemoQuery;
	},
	{},
	{},
	{}
>;

export const approvalsEntryPoint: EntryPoint<ApprovalsEntryPointComponent, EntryPointRouteParams> =
	createEntryPoint({
		root: JSResourceForUserVisible<ApprovalsEntryPointComponent>(
			/* webpackChunkName: "async-business-approvals-entrypoint" */ './JiraBusinessApprovalsAppMemo.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: ({ context, tenantContext: { cloudId } }: EntryPointRouteParams) => {
			const projectKey = context.match.params.projectKey;

			if (projectKey == null) {
				throw new Error('Project key missing');
			}

			return {
				queries: {
					approvalsQuery: {
						options: {
							fetchPolicy: 'store-and-network' as const,
						},
						parameters,
						variables: {
							cloudId,
							projectKey,
						},
					},
				},
			};
		},
	});
